import { render, staticRenderFns } from "./public-header.vue?vue&type=template&id=117d80f0&scoped=true"
import script from "./public-header.vue?vue&type=script&lang=js"
export * from "./public-header.vue?vue&type=script&lang=js"
import style0 from "./public-header.vue?vue&type=style&index=0&id=117d80f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117d80f0",
  null
  
)

export default component.exports